import React, {useEffect} from 'react';
import { NavLink } from "react-router-dom";
import Image from "../../../assets/images/platforms/health/image.png";

const Health = () => {

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    return () => {};
  }, []);

  return (
    <div className="" style={{ marginTop: "-80px" }}>
      <div className="container">
        <div className="platform-page-container">
          <div className="platform-page-inner">
            <div className="container">
              {" "}
              <img src={Image} alt="" className="p-image" />
            </div>
            <div className="">
              <p>
                You can tackle any of your health expenditure through this
                platform. It helps you and your family repay your medical
                charges in your salary.
              </p>
            </div>
            <div className="signup-btn-primary">
              <NavLink to="/sign-up">
                <button className="primary-btn">Get Started</button>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Health